var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dataLoading,
          expression: "dataLoading",
        },
      ],
      staticClass: "manager-container",
    },
    [
      _vm._m(0),
      _c(
        "el-row",
        { staticClass: "shadow-border-bottom", attrs: { type: "flex" } },
        [
          _c("div", { staticClass: "button-block" }, [
            _c(
              "div",
              { staticClass: "query-item" },
              [
                _c("el-date-picker", {
                  attrs: {
                    clearable: "",
                    type: "daterange",
                    format: "yyyy-MM-dd",
                    "range-separator": "-",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                  },
                  on: { change: _vm.getLogs },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "query-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "Search By User Name", clearable: "" },
                  nativeOn: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getLogs()
                    },
                  },
                  model: {
                    value: _vm.userNameSearch,
                    callback: function ($$v) {
                      _vm.userNameSearch = $$v
                    },
                    expression: "userNameSearch",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "query-item" },
              [
                _c("el-input", {
                  attrs: { placeholder: "Search By IP", clearable: "" },
                  nativeOn: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getLogs()
                    },
                  },
                  model: {
                    value: _vm.ipSearch,
                    callback: function ($$v) {
                      _vm.ipSearch = $$v
                    },
                    expression: "ipSearch",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "query-item" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "Select Client Type", clearable: "" },
                    on: { change: _vm.getLogs },
                    model: {
                      value: _vm.clientTypeSearch,
                      callback: function ($$v) {
                        _vm.clientTypeSearch = $$v
                      },
                      expression: "clientTypeSearch",
                    },
                  },
                  _vm._l(_vm.clientTypeSelect, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "table-block", style: { height: "calc(100% - 85px)" } },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                "empty-text": "No data found",
                border: "",
                height: "100%",
                "header-cell-style": _vm.HEADER_CELL_STYLE,
                "cell-style": _vm.CELL_STYLE,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "ip", label: "Client IP", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "userAgent", label: "User Agent", width: "200" },
              }),
              _c("el-table-column", {
                attrs: { prop: "userName", label: "User Name", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { prop: "roleName", label: "Role Name", width: "150" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "clientType",
                  label: "Client Type",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.clientType === "1"
                                  ? "Web"
                                  : scope.row.clientType === "2"
                                  ? "Tablet"
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "Log Title", width: "200" },
              }),
              _c("el-table-column", {
                attrs: { prop: "requestUri", label: "URI", width: "200" },
              }),
              _c("el-table-column", {
                attrs: { prop: "params", label: "Payload", width: "300" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "resultParams",
                  label: "Response",
                  width: "300",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.resultParams
                          ? [
                              _c(
                                "el-collapse",
                                { staticClass: "no-border" },
                                [
                                  _c(
                                    "el-collapse-item",
                                    { attrs: { title: "Response Params" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            gap: "5px",
                                          },
                                        },
                                        [
                                          _c("pre", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatJson(
                                                  scope.row.resultParams
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          : [_c("div")],
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "operateDate",
                  label: "Operation Time",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "startTime", label: "Start Time", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { prop: "endTime", label: "End Time", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { prop: "logId", label: "Log ID", width: "150" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex", "justify-content": "flex-end" } },
        [
          _c("el-pagination", {
            staticStyle: { position: "absolute" },
            attrs: {
              background: "",
              "page-size": _vm.pagination.pageSize,
              "page-sizes": [5, 10, 20, 50, 100],
              "current-page": _vm.pagination.pageNumber,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pagination.total,
            },
            on: {
              "size-change": _vm.handlePageSizeChange,
              "current-change": _vm.handlePageNumberChange,
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.pagination, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.pagination, "pageSize", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-between-row" }, [
      _c("h1", { staticClass: "div-main-view-title" }, [_vm._v("System Log")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }